import { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';


// @mui
import { Link, Stack, IconButton, InputAdornment, TextField,  Box,  Typography } from '@mui/material';
import { LoadingButton } from '@mui/lab';

// components
import Iconify from '../../../components/iconify';
import { sendEmailOnForgetPassword, resetPassword } from '../../../api/auth';


// ----------------------------------------------------------------------
const { REACT_APP_RESTAURANT_ID} = process.env;

export default function ForgetPassword({ setSnackbarMessage, setSnackbarOpen }) {
  const { user } = useParams()
  const navigate = useNavigate();
  // console.log({account});
  const [resetPasswordState, setResetPasswordState] = useState(false)
  const [showPassword, setShowPassword] = useState(false);
  const [isLoading, setIsLoading] = useState(false)

  const [email, setEmail] = useState("");
  const [inputs, setInputs] = useState({
    email: "",
    otp: "",
    password: "",
  })


  const handleChange = (e) => {
    if (resetPasswordState) {
      setInputs((prev) => ({ ...prev, [e.target.name]: e.target.value }))
    }
    else {
      setEmail(e.target.value)
      setInputs({ ...inputs, email: e.target.value })
    }
  };
  const handleSubmit = async (e) => {
    e.preventDefault()
    setIsLoading(true)
    try {
      const { data } = resetPasswordState ? await resetPassword(inputs) : await sendEmailOnForgetPassword({ "email": inputs.email, restaurantId: REACT_APP_RESTAURANT_ID});

      // console.log(data);
      if (data.success) {
        setIsLoading(false)
        setSnackbarMessage({ msg: data.message, success: true })
        setSnackbarOpen(true)
        if (resetPasswordState) { navigate(user === 'superadmin' ? `/reset-password/${user}/success` : '/reset-password/success') }
        else { setResetPasswordState(true) }
      }
      else {
        setIsLoading(false)
        setSnackbarMessage({ msg: data.message, success: false })
        setSnackbarOpen(true)

      }
    } catch (error) {
      setIsLoading(false)
      setSnackbarMessage({ msg: error.message, success: false })
      setSnackbarOpen(true)

    }


  };

  return (
    <>

      <Box component='form' onSubmit={handleSubmit} >
        <Box >
          {resetPasswordState ?
            <Stack spacing={2} sx={{ p: { xs: 2, sm: 0 } }} position='relative'>
              <Stack>
                <Typography variant='h4' >Reset password?</Typography>
                <Typography variant='body' >Please enter the otp sent to your email </Typography>

              </Stack>
              <TextField
                name="otp"
                label="OTP"
                value={inputs.otp}
                onChange={handleChange}
                required
                sx={{ backgroundColor: '#fff', borderRadius: 2 }}
              />

              <TextField
                name="password"
                label="New Password"
                onChange={handleChange}
                type={showPassword ? 'text' : 'password'}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton onClick={() => setShowPassword(!showPassword)} edge="end">
                        <Iconify icon={showPassword ? 'eva:eye-fill' : 'eva:eye-off-fill'} />
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
                required
                sx={{ backgroundColor: '#fff', borderRadius: 2 }}
              />
            </Stack>
            :
            <Stack spacing={2} sx={{ p: { xs: 2, sm: 0 } }} position='relative'>
              <Stack>
                <Typography variant='h4' >Forget password?</Typography>
                <Typography variant='body' >Please enter the email associated with your account</Typography>

              </Stack>

              <TextField
                fullWidth
                name="email"
                label="Email address"
                value={email}
                onChange={handleChange}
                required
                sx={{ backgroundColor: '#fff', borderRadius: 2 }}
              />

            </Stack>
          }
        </Box>
        <Stack spacing={2} alignItems="center" justifyContent="space-between" sx={{ mt: 2 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <LoadingButton sx={{ borderRadius: 2, width: 250, backgroundColor: '#E0E082', color: '#000' }} loading={isLoading} size="large" type="submit" variant="contained">
              {resetPasswordState ? 'Reset password' : 'Send OTP'}          </LoadingButton>
          </Box>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Typography mr={1}>Remember password?</Typography>
            <Link variant="subtitle2" underline="hover" href={user === 'superadmin' ? `/login/${user}` : '/login'}>
              Login
            </Link>
          </Box>

        </Stack>

      </Box>

      {/* <Button startIcon={<ArrowBackIcon />} onClick={() => navigate('/login', { replace: true })}>
        <Typography>
          Back to log in
        </Typography>
      </Button> */}
    </>
  );
}
